import ServiceCard from "./ServiceCard";
import { cls } from "../../../NUI/utils";

function ServicesMenu({ onMenuChange, services }) {
	return (
		<div className="services-menu">
			{services.map(({category, items}) => (
				<div key={category} className="mt-12 lg:mt-9">
					<h3 className="text-lg text-left text-gray-800 mt-9 mb-6">{category}</h3>
					<div
						className={cls(
							"grid grid-cols-1 xs:grid-cols-2 gap-4",
							category?.includes("Specialised") ? "lg:grid-cols-1" : "lg:grid-cols-3 ",
						)}
					>
						{items?.map(item => (
							<ServiceCard
								key={item.title}
								icon={item.icon}
								title={item.abbr || item.title}
								description={item.description}
								price={item.price}
								href={item.href}
								ctaLink={item.ctaLink}
								onMenuChange={onMenuChange}
							/>
						))}
					</div>
				</div>
			))}
			<p className="text-xs text-is2-gray-150 text-center mt-6">* After Medicare rebate</p>
		</div>
	);
}

export default ServicesMenu;
